import KortxLogoSVG from 'assets/kortx/logo.svg?react';
import { DomainConfig } from 'libs/config';
import acmeDomainConfig from 'libs/domain/acme/domainConfig';
import {
  defaultChartPalette,
  darkPalette as defaultDarkPalette,
  lightPalette as defaultLightPalette,
} from 'theme/defaultPalettes';

// Themes generated on load, see domains
const domains: DomainConfig[] = [
  {
    key: 'DEFAULT',
    clientId: undefined,
    palettes: {
      lightPalette: defaultLightPalette,
      darkPalette: defaultDarkPalette,
      chartPalette: defaultChartPalette,
    },
    assets: {
      logo: KortxLogoSVG,
      authBg: '/auth/loginbg.jpg',
    },
  },
  ...acmeDomainConfig('acme'), // acme-test, uat etc..
];

export default domains;
